// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { PageInfoFragment } from '../../../../graphql/fragments/pageInfo.fragment.generated';
import { gql } from '@apollo/client';
import { PageInfoFragmentDoc } from '../../../../graphql/fragments/pageInfo.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EmployeeFragment = { __typename?: 'Employee', id: string, displayName: string, workosDirectoryUserID?: string | null, tier: Types.EmployeeTier, user: { __typename?: 'User', id: string, email: string }, assignedHouseholds?: Array<{ __typename?: 'Household', id: string, displayName: string }> | null, roles?: Array<{ __typename?: 'Role', id: string, displayName: string }> | null, teams?: Array<{ __typename?: 'Team', id: string, name: string }> | null };

export type GetAdminUsersQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.EmployeeWhereInput>;
  first: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
}>;


export type GetAdminUsersQuery = { __typename?: 'Query', paginatedData: { __typename?: 'EmployeeConnection', totalCount: number, pageInfo: (
      { __typename?: 'PageInfo' }
      & PageInfoFragment
    ), edges?: Array<{ __typename?: 'EmployeeEdge', node?: (
        { __typename?: 'Employee' }
        & EmployeeFragment
      ) | null } | null> | null } };

export type GetAdminUserFilterOptionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAdminUserFilterOptionsQuery = { __typename?: 'Query', roles: { __typename?: 'RoleConnection', edges?: Array<{ __typename?: 'RoleEdge', node?: { __typename?: 'Role', id: string, displayName: string } | null } | null> | null }, teams: { __typename?: 'TeamConnection', edges?: Array<{ __typename?: 'TeamEdge', node?: { __typename?: 'Team', id: string, name: string } | null } | null> | null } };

export const Operations = {
  Query: {
    GetAdminUsers: 'GetAdminUsers' as const,
    GetAdminUserFilterOptions: 'GetAdminUserFilterOptions' as const
  },
  Fragment: {
    Employee: 'Employee' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const EmployeeFragmentDoc = gql`
    fragment Employee on Employee {
  id
  displayName
  workosDirectoryUserID
  user {
    id
    email
  }
  assignedHouseholds {
    id
    displayName
  }
  roles {
    id
    displayName
  }
  teams {
    id
    name
  }
  tier
}
    `;
export const GetAdminUsersDocument = gql`
    query GetAdminUsers($where: EmployeeWhereInput, $first: Int!, $after: Cursor) {
  paginatedData: employees(where: $where, first: $first, after: $after) {
    totalCount
    pageInfo {
      ...PageInfo
    }
    edges {
      node {
        ...Employee
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${EmployeeFragmentDoc}`;

/**
 * __useGetAdminUsersQuery__
 *
 * To run a query within a React component, call `useGetAdminUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminUsersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetAdminUsersQuery(baseOptions: Apollo.QueryHookOptions<GetAdminUsersQuery, GetAdminUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminUsersQuery, GetAdminUsersQueryVariables>(GetAdminUsersDocument, withFetchPolicyContext(options));
      }
export function useGetAdminUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminUsersQuery, GetAdminUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminUsersQuery, GetAdminUsersQueryVariables>(GetAdminUsersDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetAdminUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminUsersQuery, GetAdminUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdminUsersQuery, GetAdminUsersQueryVariables>(GetAdminUsersDocument, withFetchPolicyContext(options));
        }
export type GetAdminUsersQueryHookResult = ReturnType<typeof useGetAdminUsersQuery>;
export type GetAdminUsersLazyQueryHookResult = ReturnType<typeof useGetAdminUsersLazyQuery>;
export type GetAdminUsersSuspenseQueryHookResult = ReturnType<typeof useGetAdminUsersSuspenseQuery>;
export type GetAdminUsersQueryResult = Apollo.QueryResult<GetAdminUsersQuery, GetAdminUsersQueryVariables>;
export const GetAdminUserFilterOptionsDocument = gql`
    query GetAdminUserFilterOptions {
  roles(where: {kindIn: [CUSTOM, ADMINISTRATOR]}) {
    edges {
      node {
        id
        displayName
      }
    }
  }
  teams {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetAdminUserFilterOptionsQuery__
 *
 * To run a query within a React component, call `useGetAdminUserFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminUserFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminUserFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdminUserFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminUserFilterOptionsQuery, GetAdminUserFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminUserFilterOptionsQuery, GetAdminUserFilterOptionsQueryVariables>(GetAdminUserFilterOptionsDocument, withFetchPolicyContext(options));
      }
export function useGetAdminUserFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminUserFilterOptionsQuery, GetAdminUserFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminUserFilterOptionsQuery, GetAdminUserFilterOptionsQueryVariables>(GetAdminUserFilterOptionsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetAdminUserFilterOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminUserFilterOptionsQuery, GetAdminUserFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdminUserFilterOptionsQuery, GetAdminUserFilterOptionsQueryVariables>(GetAdminUserFilterOptionsDocument, withFetchPolicyContext(options));
        }
export type GetAdminUserFilterOptionsQueryHookResult = ReturnType<typeof useGetAdminUserFilterOptionsQuery>;
export type GetAdminUserFilterOptionsLazyQueryHookResult = ReturnType<typeof useGetAdminUserFilterOptionsLazyQuery>;
export type GetAdminUserFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useGetAdminUserFilterOptionsSuspenseQuery>;
export type GetAdminUserFilterOptionsQueryResult = Apollo.QueryResult<GetAdminUserFilterOptionsQuery, GetAdminUserFilterOptionsQueryVariables>;